export default {"src":"/_next/static/media/wi-fi.ea437dac.svg","height":46,"width":46,"blurWidth":0,"blurHeight":0};